export const TEMP_RANGES = {
  instantHeat: { fahrenheit: [250, 1830], celsius: [121, 999] },
  constantTemp: { fahrenheit: [77, 248], celsius: [25, 120] },
};


TEMP_RANGES.heatingSchedule = TEMP_RANGES.instantHeat;


export const validateTemp = (temp, control, isF) => {
  const range = TEMP_RANGES[control];
  if (!range) return false;
  const [min, max] = isF ? range.fahrenheit : range.celsius;

  if (control === 'constantTemp') {
    return temp > min && temp < max;
  }
  return temp >= min && temp <= max;
};

export const TEMP_ERROR_MESSAGES = {
  instantHeat: [
    'wrong temperature',
    'in order to finalize instant heat program,',
    'please input your temperature first',
    '( the minimum temperature is 121\u00B0C - 250\u00B0F )',
    '( the maximum temperature is 999\u00B0C - 1830\u00B0F )',
  ],
  constantTemp: [
    'wrong temperature',
    'in order to finalize instant heat program,',
    'please input your temperature first',
    '( the minimum temperature is 24\u00B0C - 77\u00B0F )',
    '( the maximum temperature is 120\u00B0C - 248\u00B0F )',
  ],
  selectLocation: [
    'select locations',
    'please select location to continue',
  ],
};


TEMP_ERROR_MESSAGES.heatingSchedule = TEMP_ERROR_MESSAGES.instantHeat;
